import { type AxiosInstance } from "axios";
import type {
  OrderAmountRequest,
  OrderAmountResponse,
} from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 発注の金額見積もりを取得する。
 * @param apiClient - axios インスタンス
 * @param params - 金額算出パラメータ（デザインID・部数等）
 * @returns 金額見積もり結果
 */
export const GetOrderAmountAPI = async (
  apiClient: AxiosInstance,
  params: OrderAmountRequest,
  signal?: AbortSignal
): Promise<OrderAmountResponse> => {
  const url = "/dm/orders/amount/";

  try {
    const response = await apiClient.get<OrderAmountResponse>(url, {
      params,
      signal,
    });
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
